import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { AccessEventsDateRange, MobileOpCode } from 'graphql/generated/graphqlTypes';

dayjs.extend(utc);

/** The access event actions shown by default; every access events query should use this list. */
export const DEFAULT_ACCESS_EVENT_ACTIONS = [
  MobileOpCode.AccessDenied,
  MobileOpCode.AccessGranted,
  MobileOpCode.ResultPending
] as const;

export type AccessFilterAction = (typeof DEFAULT_ACCESS_EVENT_ACTIONS)[number];

/**
 * Normalises a filter date range for `getAccessEventsForTenant`.
 *
 * The pickers only go down to minutes, so the range covers whole minutes: it starts at the very
 * beginning of the chosen start minute and ends at the very last millisecond of the chosen end
 * minute — events are stored with millisecond precision, so that upper bound includes all of them.
 * Ending the range before that would both drop the minute's own events and, when start and end fall
 * inside the same minute, put the upper bound below the lower one, which the API rejects outright.
 */
export const getAccessEventsDateRange = (dateRange: AccessEventsDateRange) => ({
  rangeStart: dayjs(dateRange.rangeStart).startOf('minute').utc().toISOString(),
  rangeEnd: dayjs(dateRange.rangeEnd).endOf('minute').utc().toISOString()
});
